module.exports = __webpack_public_path__ + "img/1d17e35.png";